import { inject, Injectable } from "@angular/core";
import {
  Action,
  createSelector,
  Selector,
  State,
  StateContext} from "@ngxs/store";
import { toStreamerFolowings } from "../../mapper/streamer-follow.mapper";
import { StreamerFollow } from "../../model/streamer-follow.model";
import { StreamerFollowService } from "../../service/streamer-follow.service";
import {
  LoadStreamerFollowing,
  ReloadStreamerFollowing,
  ClearStreamerFollowing} from "./streamer-following.action";
export class StreamerFollowingStateModel {
  page: number;
  pageSize: number;
  total: number;
  pages: Record<number, StreamerFollow[]>;
  loading: boolean;
  error: Error | undefined;
}

@State<StreamerFollowingStateModel>({
  name: "streamerFollowing",
  defaults: {
    page: 1,
    pageSize: 10,
    total: 0,
    pages: {},
    loading: false,
    error: undefined}})
@Injectable()
export class StreamerFollowingState {
  streamerFollowService = inject(StreamerFollowService);

  @Selector()
  static isLoading(state: StreamerFollowingStateModel) {
    return state.loading;
  }

  @Selector()
  static hasError(state: StreamerFollowingStateModel) {
    return !!state.error;
  }

  @Selector()
  static currentPageData(state: StreamerFollowingStateModel) {
    return state.pages[state.page] || [];
  }

  static pageData(page: number) {
    return createSelector(
      [StreamerFollowingState],
      (state: StreamerFollowingStateModel) => state.pages[page] || [],
    );
  }

  @Selector()
  static pagination(state: StreamerFollowingStateModel) {
    return {
      page: state.page,
      pageSize: state.pageSize,
      total: state.total,
      totalPages: Math.ceil(state.total / state.pageSize)};
  }

  @Action(LoadStreamerFollowing)
  async loadStreamerFollowing(
    ctx: StateContext<StreamerFollowingStateModel>,
    action: LoadStreamerFollowing,
  ) {
    const state = ctx.getState();
    const nextPage = action.page ?? state.page;
    const nextPageSize = action.pageSize ?? state.pageSize;
    const key = nextPage;
    if (state.pages[nextPage]) {
      ctx.patchState({
        page: nextPage,
        pageSize: nextPageSize,
        loading: false,
        error: undefined});
      return;
    }
    ctx.patchState({
      loading: true,
      page: nextPage,
      pageSize: nextPageSize,
      error: undefined});

    try {
      const response = await this.streamerFollowService.following(
        nextPage,
        nextPageSize,
      );
      const following = toStreamerFolowings(response);

      const total = response.pagination.total;

      const current = ctx.getState();
      ctx.patchState({
        loading: false,
        total,
        pages: {
          ...current.pages,
          [key]: following}});
    } catch (error) {
      console.error("Erro ao carregar dados", error);
      ctx.patchState({
        loading: false,
        error: error as Error});
    }
  }

  @Action(ReloadStreamerFollowing)
  async reloadStreamerFollowing(
    ctx: StateContext<StreamerFollowingStateModel>,
  ) {
    ctx.patchState({
      page: 1,
      total: 0,
      pages: {},
      loading: true,
      error: undefined});
    ctx.dispatch(new LoadStreamerFollowing(1, 10));
  }

  @Action(ClearStreamerFollowing)
  clearStreamerFollowing(ctx: StateContext<StreamerFollowingStateModel>) {
    ctx.patchState({
      page: 1,
      pageSize: 10,
      total: 0,
      pages: {},
      loading: true,
      error: undefined});
  }
}
